export default "__VITE_ASSET__C08mDGJd__"